import _extends from 'babel-runtime/helpers/extends';

export default {
  name: 'LanguageSelector',

  componentName: 'LanguageSelector',

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {};
  },


  computed: {
    languageList: function languageList() {
      if (this.innerConfig.params.options) {
        return this.innerConfig.params.options;
      }
      return this.$store.getters.languages.map(function (item) {
        return {
          value: item.code,
          label: item.name
        };
      });
    },
    innerConfig: function innerConfig() {
      var params = _extends({
        clearable: true,
        placeholder: this.$t('playTurbo.creative.languagePacks.languageSelectorPlaceHolder')
      }, this.config.params);
      return _extends({}, this.config, {
        params: params
      });
    }
  },

  mounted: function mounted() {
    if (this.languageList && !this.languageList.length) {
      this.$store.dispatch('config/getLanguagesList');
    }
  }
};